import Vue from 'vue';

Vue.filter('currency', (input: string, symbol: string) => {
    symbol = symbol ? symbol : '$';
    const defaultVal = `${symbol}0.00`;
    if (!input) {
        return defaultVal;
    }

    const numeral = parseFloat(input);
    if (Number.isNaN(numeral)) {
        return defaultVal;
    }

    // Format number with commas and two decimals
    const formatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(numeral);

    // If you want to preserve a custom symbol instead of 'USD', replace it
    if (symbol !== '$') {
        return formatted.replace('$', symbol);
    }

    return formatted;
})